import { render, staticRenderFns } from "./OrderablePurchaseOrder.vue?vue&type=template&id=52d20034&"
import script from "./OrderablePurchaseOrder.vue?vue&type=script&lang=ts&"
export * from "./OrderablePurchaseOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports